import { Field } from "formik";
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import Select from "../../components/form-fields/Select";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import Tree from "../../components/form-fields/Tree";
import { getNestedValueFromPath } from "../../utils";
import { useTranslation } from "react-i18next";

export default function UserDepartment(props) {
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (!getNestedValueFromPath(props, "location.state.row")) {
      props.history.goBack();
    }
  }, []);

  const validationSchema = yup.object({});

  const arrangeBeforePersist = (values) => {
    let payload = {
      userId: getNestedValueFromPath(props, "location.state.row.id"),
      updateField: values.departments,
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      departments: data.updateField,
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(true);
    setInitialValues({});
  };

  const mapNativeDataBeforeList = (data) => {
    data = data.seciliTalepTurleri;
    return data;
  };

  return (
    <Main>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CrudMain
            onAddButtonClicked={onAddButtonClicked}
            showModal={showModal}
            setShowModal={setShowModal}
            title={t("userDepartment.kullaniciDepartman")}
            // showBackButton
            onBackButton={() => props.history.goBack()}
            customAddButtonTitle={t("actionButtonGenerator.guncelle")}
            size="lg"
          >
            <FormikForm
              isUpdating={isUpdating}
              entityId={getNestedValueFromPath(props, "location.state.row.id")}
              entityFetchId="userId"
              endPointUrl="user-taleptur/update"
              fetchPointUrl="user-taleptur/config"
              editPointUrl="user-taleptur/update"
              configPointUrl="user-taleptur/config"
              arrangeBeforePersist={arrangeBeforePersist}
              adaptDataForUpdate={adaptDataForUpdate}
              a
              setConfigData={(data) => {
                data.talepTurleri.label = "Tümü";
                data.talepTurleri.expanded = true;
                let treeData = [data.talepTurleri];
                setConfigData(treeData);
              }}
              configReqType={"POST"}
              initialValues={initialValues}
              validationSchema={validationSchema}
              closeModal={() => setShowModal(false)}
              refreshList={() => setRefreshList(!refreshList)}
            >
              <Field
                name="departments"
                label={t("userDepartment.talepTurleri")}
                colNumber="12"
                component={Tree}
                nodes={configData || []}
                // expanded={[0]}
              />
            </FormikForm>
          </CrudMain>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="grup-şirketleri"
            endpoint="user-taleptur/config"
            keyField="id"
            refreshList={refreshList}
            mapNativeDataBeforeList={mapNativeDataBeforeList}
            customBody={{
              userId: getNestedValueFromPath(props, "location.state.row.id"),
            }}
            columns={[
              {
                dataField: "id",
                text: t("userDepartment.talepTurleriId"),
                sort: true,
              },
              {
                dataField: "talepTuru",
                text: t("userDepartment.talepTurleriAdı"),
                sort: true,
              },
            ]}
            actionButtonsObject={{
              actions: [],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
